import { httpRequest } from "@services/http";

export class CommandUpdateAd {
    async run(adId: number, patch: any) {

            const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ad/${adId}/`
            try {
                const response = await httpRequest(url, {
                    method: "PUT",
                    body: JSON.stringify(patch)
                    })
                return response

            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        }

}
